// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/Traducoes_ListaResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for GET /config/traducoes/lista.
 * `total` counts every key that matched the filters, not the page returned.
 */
import type { Traducoes_ItemRow } from './Traducoes_ItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export interface Traducoes_ListaResponseDados {
itens: Traducoes_ItemRow[]
total: number
}

export type Traducoes_ListaResponse = ApiResponse<Traducoes_ListaResponseDados>;

registerResponseContract('Traducoes_ListaResponse', {
  itens: {
    type: 'array',
    required: true,
    items: {
      pagina:    { type: 'string',  required: false },
      chave:     { type: 'string',  required: false },
      traducoes: { type: 'object',  required: false },
      faltantes: { type: 'array',   required: false },
    },
  },
  total: { type: 'number',  required: true },
})
